import CustomForm from "../CustomForm";
import {TextboxItem} from "../../model/items/textbox";
import {TextareaItem} from "../../model/items/textarea";
import CheckboxCell from "../shared/components/FormCell/CheckboxCell";
import MediaPlayer from "../shared/components/MediaPlayer/MediaPlayer";
import ICustomFormSettings from "../ICustomFormSettings";
import {CheckboxItem} from "../../model/items/checkbox";
import {LabelItem} from "../../model/items/labelItem";
import m, {Vnode} from "mithril";

export default abstract class Player extends CustomForm {
    protected readonly fulfilledField: TextboxItem;
    protected readonly eventField?: TextareaItem;
    protected readonly globalUnknown?: CheckboxCell;
    protected readonly link: string;
    protected readonly config?: any;

    protected abstract player: MediaPlayer;

    constructor(settings: ICustomFormSettings) {
        super(settings);

        const layout = settings.form.grid.layout;
        this.fulfilledField = <TextboxItem>layout[0][0].cellItems[0];

        this.eventField = <TextareaItem|undefined>layout[1][0].cellItems[0];

        const checkbox = <CheckboxItem|undefined>layout[2][0].cellItems[0];
        if (checkbox instanceof CheckboxItem && checkbox.globalUnknown) {
            this.globalUnknown = new CheckboxCell(checkbox.cell, this.onSetValue.bind(this));
        }

        this.link = (<LabelItem>layout[3][0].cellItems[0])?.childrenTags[0]?.value || '';

        const configString = (<LabelItem>layout[4][0].cellItems[0])?.childrenTags[0]?.value || '{}';
        try {
            this.config = JSON.parse(configString);
        } catch (e) {
            this.config = {};
        }
    }

    public view(): Vnode {
        return this.viewLayout([
            m(this.player),
            this.globalUnknown ? m(this.globalUnknown) : null,
        ]);
    }
}